var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-section',{staticClass:"teacher__area po-rel-z1 pt-120 pb-145",attrs:{"fill-height":"","center-items":""}},[_c('instructor-article')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }